import type { ClassSeasonDetails } from './server/class-season.loader';
import type { AvailableClassData } from './server/server-actions';

/** Seasons are schedule-level offers; only individual sessions need a date. */
export function getClassBookingChoices({
  seasons,
  sessions,
  bookingType,
  sportId,
  allSports = false,
  locationId,
}: {
  seasons: ClassSeasonDetails[];
  sessions: AvailableClassData[];
  bookingType: string;
  sportId: string | undefined;
  allSports?: boolean;
  locationId: string | null;
}) {
  const visibleSeasons = seasons.filter((season) => {
    if (locationId && season.locationId && season.locationId !== locationId) {
      return false;
    }

    if (bookingType === 'all') return true;
    if (allSports) return season.category === bookingType;
    return !!sportId && season.sportId === sportId && season.category === bookingType;
  });

  const individualSessions = sessions.filter((session) => !session.season);

  return {
    seasons: visibleSeasons,
    individualSessions,
    needsCalendar: visibleSeasons.length === 0 || individualSessions.length > 0,
  };
}
